<template>
  <div v-if="action.hasOwnProperty('permission') ? (typeof action.permission === 'string' ? $u.checkPermissions(action.permission) : $u.checkPermissions(action.permission) === 2) : true"
       :class="[{[`${action.type}-type-action`]: action.type}]" @click="handleChangeCollapse">
    <profile-action-item v-if="(!isMobile || action.routeType === 'event') && action.hasOwnProperty('event')"
                         class="profile-action"
                         :class="{active: collapse && action.children && action.children.length > 0}"
                         :action="action"
                         :selected-action="selectedAction"
                         @eventClick="handleClickAction($event, action)" />
    <a v-else-if="action.hasOwnProperty('routeType') && action.routeType === 'external-link'" :href="action.route" :target="action.target || ''">
      <profile-action-item class="profile-action"
                           :class="{active: collapse && action.children && action.children.length > 0}"
                           :action="action"
                           :selected-action="selectedAction"
                           @eventClick="handleClickAction($event, action)" />
    </a>
    <router-link v-else :to="{name: action.route || action.name, params: action.params || {}, query: action.query || {}}">
      <profile-action-item class="profile-action"
                           :class="{active: collapse && action.children && action.children.length > 0}"
                           :action="action"
                           :selected-action="selectedAction"
                           @eventClick="handleClickAction($event, action)" />
    </router-link>
    <transition name="fade">
      <ul v-if="collapse && action.children && action.children.length > 0" class="actions-list children-actions" @click.stop>
        <template v-for="(childAction, key) in action.children">
          <profile-action :action="childAction" :key="key" :selected-action="selectedAction" @eventClick="handleClickAction" />
        </template>
      </ul>
    </transition>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import CustomIcon from '../icon/customIcon.vue'
import ProfileActionItem from './profileActionItem.vue'

export default {
  name: 'profileAction',
  components: {ProfileActionItem, CustomIcon},
  props: {
    action: {
      type: Object,
      default: () => { return {} },
      required: true
    },
    selectedAction: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      collapse: false
    }
  },
  computed: {
    ...mapGetters({
      isMobile: 'isMobile'
    }),
    checkActionIsActive () {
      if (this.action.hasOwnProperty('event')) {
        return this.selectedAction === this.action.event || this.selectedAction === this.action.name
      } else return false
    }
  },
  methods: {
    handleClickAction (event, action) {
      if ((!this.isMobile || action.routeType === 'event') && action.hasOwnProperty('event')) {
        this.$emit('eventClick', action.event)
      }
    },
    handleChangeCollapse () {
      if (this.selectedAction === this.action.name) {
        this.collapse = !this.collapse
      } else {
        this.collapse = true
      }
    }
  },
  watch: {
    'action.children': {
      handler (val) {
        this.collapse = val.length > 0
      }
    }
  }
}
</script>

<style lang="scss">
.important-type-action {
  text-align: center;
  display: flex;
  align-items: center;
  flex-direction: column;
  //width: fit-content !important;
  padding: 5px;
  width: 33%;
  aspect-ratio: 1;
  max-width: 120px;

  a {
    width: 100%;
    height: 100%;
  }

  .profile-action {
    flex-direction: column;
    justify-content: center;
    padding: 10px 5px;
    width: 100%;
    height: 100%;
    border-radius: 0.5rem;
    background-color: #f0f0f070;

    &:hover:not(.active) {
      background-color: #f0f0f0f0;
    }

    &.active {
      .action-label {
        font-size: 12px;
      }

      &:after {
        content: ' ';
        height: 3px;
        width: 40px;
        background-color: #eea1a0;
        border-radius: 0.5rem;
        position: absolute;
        top: calc(100% - 4px);
        left: calc(50% - 20px);
        right: calc(50% - 20px);
      }
    }

    .action-icon {
      margin: 0;
      font-size: 23px;
    }

    i {
      margin: 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .action-label {
      font-size: 13px;
      line-height: 20px;
      margin-top: 10px;
      width: 100% !important;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
}

.children-actions {
  border-left: 1px solid #cecece;
  margin-left: 20px;
  margin-top: 5px;
  margin-bottom: 5px;
  padding-left: 0;
}
</style>
